<template>
  <router-view/>
</template>

<script>


export default {
  name: "App",

  components: {},

  data: () => ({
  }),

  computed: {
   
  },
  methods: {
  }, 
  mounted() 
  {
     let elHtml = document.getElementsByTagName('html')[0];
     elHtml.style.overflowY = 'auto';
  }
};
</script>
